import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import 'rxjs/Rx';

@Injectable({
  providedIn: 'root'
})
export class GetPromissoryNotesByIdService {

  constructor(
    private http: HttpClient
  ) {}

  getPromiseNotes() {

  }

  getPromiseNotes_(tipoDocumento_: string, idDocumentoPagare_: string) {

    const body = new HttpParams();
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${localStorage.getItem('tokenId')}` });

    return this.http.get(`https://www.mundofinanciera.com:9091/api/mf/consultaPagare/?idTipoIdentificacionFirmante=${tipoDocumento_}&idEstadoPagare=6&numIdentificacionFirmante=${idDocumentoPagare_}`, { headers, observe: 'response' });
  }

}
